<template>
  <div class="pt-4">
    <InvoiceDetails />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { RouteName } from '@/types/router'
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import { useBreadcrumbRegistry } from '@/composables/use-breadcrumb-registry.ts'
import InvoiceDetails from '@/components/deepadmin/billing/invoices/InvoiceDetails.vue'

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})

const { t } = useI18n()
const route = useRoute()
const { overrideBreadcrumb } = useBreadcrumbRegistry()
const { permissions } = useAuthorizationContext()
const { selectedOrganization } = useAccountMembershipsContext()

const invoiceId = computed<number>(() =>
  parseInt(route.params.invoiceId as string),
)

watch(
  invoiceId,
  (newValue) => {
    if (!newValue) return

    overrideBreadcrumb(
      '/organizations/[organizationId]/billing/invoices/[invoiceId]/' as RouteName,
      t('navigation.organization.billing.invoice_detail', {
        invoiceId: invoiceId.value,
      }),
    )
  },
  { immediate: true },
)

usePageAccess(
  computed(
    () =>
      !permissions.canManageSubscription ||
      selectedOrganization.value?.resource.verification?.state !== 'verified',
  ),
  '/organizations/[organizationId]/billing/invoices/',
)
</script>
